import { toast } from "react-toastify";

export const successToast = (message) => {
  return toast.success(message, {
    position: "top-right",
    autoClose: 3000,
  });
};

export const errorToast = (message) => {
  return toast.error(message, {
    position: "top-right",
    autoClose: 3000,
  });
};
